import React from 'react'
import { useRoutes } from 'react-router-dom'

// UI

//COnstant
import NotFoundPage from '@/components/Page/NotFoundPage'
import UnauthorizedPage from '@/components/Page/UnauthorizedPage'
import PrivateRouteMiddleware from './middlewares/PrivateRouteMiddleware'
import PublicRouteMiddleware from './middlewares/PublicRouteMiddleware'

//Routes

import privateRoutes from './PrivateRoutes/index.jsx'
import publicRoutes from './PublicRoutes'
import allVisibleRoutes from './AllVisibleRoutes'

const AppRoutes = () => {
  const element = useRoutes([
    {
      element: <PrivateRouteMiddleware />,
      children: privateRoutes,
    },
    {
      element: <PublicRouteMiddleware />,
      children: publicRoutes,
    },
    ...allVisibleRoutes,

    {
      path: 'external/unauthorized',
      element: <UnauthorizedPage />,
    },
    {
      breadcrumb: '404',
      path: '*',
      element: <NotFoundPage />,
    },
  ])

  return <>{element}</>
}

export default AppRoutes
